import { useState } from 'react';

/**
 * Barra de búsqueda flotante del mapa base (README diseño, sección 5.1).
 * Nombre y logo vienen de la configuración de esta instancia (HU-005,
 * `useConfiguracion` en `MapaPrincipal`) — sin logo propio se muestra la
 * inicial del nombre de la entidad, nunca un logo de marca fijo en código.
 *
 * `onBuscar(texto)` con `{ soloEscribir: true }` (al tipear) dispara la
 * búsqueda debounced que llena `sugerencias`; `onBuscar(texto)` (Enter/botón)
 * centra el mapa. `onSeleccionar(resultado)` elige una sugerencia de la lista.
 */
const TopSearchBar = ({
  nombreEntidad = 'Cifra Negra',
  logo = null,
  valor,
  onBuscar,
  buscando = false,
  sugerencias = [],
  onSeleccionar,
}) => {
  const [enfocado, setEnfocado] = useState(false);
  const mostrarLista = enfocado && sugerencias.length > 0;

  const manejarEnvio = (e) => {
    e.preventDefault();
    onBuscar?.(valor);
  };

  return (
    <div className="mp-search-wrap">
      <form className="mp-search-bar" onSubmit={manejarEnvio}>
        <div className="mp-logo">
          {logo ? <img src={logo} alt={`Logo ${nombreEntidad}`} /> : <span>{nombreEntidad?.[0] || 'C'}</span>}
        </div>
        <span className="mp-entidad-nombre">{nombreEntidad}</span>
        <input
          type="text"
          placeholder="Buscar dirección, vía o zona"
          value={valor}
          onChange={(e) => onBuscar?.(e.target.value, { soloEscribir: true })}
          onFocus={() => setEnfocado(true)}
          onBlur={() => setTimeout(() => setEnfocado(false), 150)}
          aria-label="Buscar dirección, vía o zona"
        />
        <button type="submit" className="mp-search-icon" aria-label="Buscar" disabled={buscando}>
          <i className={`fas ${buscando ? 'fa-spinner fa-spin' : 'fa-search'}`} aria-hidden="true"></i>
        </button>
      </form>

      {mostrarLista && (
        <ul className="mp-search-sugerencias" role="listbox">
          {sugerencias.map((s) => (
            <li key={s.place_id ?? s.display_name}>
              <button
                type="button"
                className="mp-sugerencia"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => onSeleccionar?.(s)}
              >
                <span className="mp-sugerencia-tipo">{s._label || 'Dirección'}</span>
                <span className="mp-sugerencia-texto">
                  <span className="mp-sugerencia-titulo">{s._titulo || s.display_name}</span>
                  {s._subtitulo ? <span className="mp-sugerencia-sub">{s._subtitulo}</span> : null}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TopSearchBar;
